import { queryOptions } from '@tanstack/react-query';
import * as guidedExperiencesApi from '../endpoints/guided-experiences';
import type { EligibleExperiencesResponseWire, GuidedExperienceStateWire } from '../schemas/guided-experience';

export const GUIDED_EXPERIENCE_QUERY_KEYS = {
  all: ['guided-experiences'] as const,
  eligible: () => [...GUIDED_EXPERIENCE_QUERY_KEYS.all, 'eligible'] as const,
  state: (experienceId: string) =>
    [...GUIDED_EXPERIENCE_QUERY_KEYS.all, 'state', experienceId] as const,
} as const;

export const eligibleExperiencesQueryOptions = () =>
  queryOptions({
    queryKey: GUIDED_EXPERIENCE_QUERY_KEYS.eligible(),
    queryFn: async (): Promise<EligibleExperiencesResponseWire> => {
      return guidedExperiencesApi.getEligibleExperiences();
    },
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    meta: { persist: false },
  });

export const experienceStateQueryOptions = (experienceId: string) =>
  queryOptions({
    queryKey: GUIDED_EXPERIENCE_QUERY_KEYS.state(experienceId),
    queryFn: async (): Promise<GuidedExperienceStateWire> => {
      return guidedExperiencesApi.getExperienceState(experienceId);
    },
    enabled: !!experienceId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
    meta: { persist: false },
  });
